import styled from "styled-components";
import { rotatingShineAnimation } from "../../animations";

export const ButtonShineLayer = styled.div`
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	overflow: hidden;
	font-size: 10px;
	z-index: 0;
	pointer-events: none;
`;

export const ButtonShine = styled.img<{ $left: number; $top: number }>`
	position: absolute;
	top: ${({ $top }) => `${$top}px`};
	left: ${({ $left }) => `${$left}px`};
	width: 13.2em;
	height: 13.2em;
	opacity: 0.8;
	${rotatingShineAnimation}
`;
